import axios from "axios";

export const getMasterJson = async (fileName) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_JSON}${fileName}`);
    return { data: response.data, status: response.status };
  } catch (error) {
    return {
      data: error.response?.data ?? "api error",
      status: error.response?.status,
    };
  }
};